import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const Navigation = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const isActive = (path) => {
    return location.pathname === path;
  };

  const useDarkText = false;
  const logoColor = useDarkText ? 'text-gray-900 hover:text-yellow-600' : 'text-white hover:text-yellow-400';
  const brandAccent = useDarkText ? 'text-yellow-600' : 'text-yellow-400';
  const navLinkBase = useDarkText ? 'nav-link nav-link-dark' : 'nav-link';
  const activeAccent = useDarkText ? 'text-yellow-600' : 'text-yellow-400';
  const mobileBtnColor = useDarkText ? 'text-gray-900 hover:text-yellow-600' : 'text-white hover:text-yellow-400';

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ? 'bg-black/90 backdrop-blur-md py-4' : 'bg-transparent py-6'
    }`}>
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className={`text-xl font-bold transition-colors ${logoColor}`}>
            <span className={brandAccent}>ROMERO</span> SUMPTER
          </Link>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-8">
            <Link 
              to="/" 
              className={`${navLinkBase} ${isActive('/') ? activeAccent : ''}`}
              onClick={closeMenu}
            >
              Home
            </Link>
            <Link 
              to="/ministry" 
              className={`${navLinkBase} ${isActive('/ministry') ? activeAccent : ''}`}
              onClick={closeMenu}
            >
              Ministry
            </Link>
            <Link 
              to="/books" 
              className={`${navLinkBase} ${isActive('/books') ? activeAccent : ''}`}
              onClick={closeMenu}
            >
              Books
            </Link>
            <Link 
              to="/clothier" 
              className={`${navLinkBase} ${isActive('/clothier') ? activeAccent : ''}`}
              onClick={closeMenu}
            >
              Clothier
            </Link>
            <Link 
              to="/academy" 
              className={`${navLinkBase} ${isActive('/academy') ? activeAccent : ''}`}
              onClick={closeMenu}
            >
              Academy
            </Link>
            <Link 
              to="/furniture" 
              className={`${navLinkBase} ${isActive('/furniture') ? activeAccent : ''}`}
              onClick={closeMenu}
              data-testid="nav-furniture"
            >
              Furniture
            </Link>
            <Link 
              to="/contact" 
              className={`${navLinkBase} ${isActive('/contact') ? activeAccent : ''}`}
              onClick={closeMenu}
            >
              Contact
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button 
            className={`md:hidden transition-colors ${mobileBtnColor}`}
            onClick={toggleMenu}
            aria-label="Toggle menu"
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden absolute top-full left-0 right-0 bg-black/95 backdrop-blur-md border-t border-gray-800">
            <div className="flex flex-col py-4">
              <Link 
                to="/" 
                className={`nav-link block px-4 py-3 ${isActive('/') ? 'text-yellow-400' : ''}`}
                onClick={closeMenu}
              >
                Home
              </Link>
              <Link 
                to="/ministry" 
                className={`nav-link block px-4 py-3 ${isActive('/ministry') ? 'text-yellow-400' : ''}`}
                onClick={closeMenu}
              >
                Ministry
              </Link>
              <Link 
                to="/books" 
                className={`nav-link block px-4 py-3 ${isActive('/books') ? 'text-yellow-400' : ''}`}
                onClick={closeMenu}
              >
                Books
              </Link>
              <Link 
                to="/clothier" 
                className={`nav-link block px-4 py-3 ${isActive('/clothier') ? 'text-yellow-400' : ''}`}
                onClick={closeMenu}
              >
                Clothier
              </Link>
              <Link 
                to="/academy" 
                className={`nav-link block px-4 py-3 ${isActive('/academy') ? 'text-yellow-400' : ''}`}
                onClick={closeMenu}
              >
                Academy
              </Link>
              <Link 
                to="/furniture" 
                className={`nav-link block px-4 py-3 ${isActive('/furniture') ? 'text-yellow-400' : ''}`}
                onClick={closeMenu}
              >
                Furniture
              </Link>
              <Link 
                to="/contact" 
                className={`nav-link block px-4 py-3 ${isActive('/contact') ? 'text-yellow-400' : ''}`}
                onClick={closeMenu}
              >
                Contact
              </Link>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navigation;